import React, { useEffect, useState } from "react";
import { useLang } from "@/i18n";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SEO from "@/components/SEO";

export default function FAQ() {
  const { t, tt } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/faqs").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <SEO title={t("nav.faq")} />
      <div className="section-warm py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.35em] text-brand-orange font-semibold mb-3">{t("nav.faq")}</div>
          <h1 className="font-serif text-5xl md:text-6xl text-brand-navy" data-testid="faq-title">{t("sections.faq_title")}</h1>
          <p className="mt-3 text-slate-700 max-w-2xl">{t("sections.faq_desc")}</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-12" data-testid="faq-list">
        <Accordion type="single" collapsible className="w-full">
          {items.map((f, i) => (
            <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${i}`} className="border-b border-brand-navy/10">
              <AccordionTrigger className="text-start font-serif text-lg text-brand-navy hover:no-underline hover:text-brand-orange">
                {tt(f.question)}
              </AccordionTrigger>
              <AccordionContent className="text-slate-700 leading-relaxed whitespace-pre-line">
                {tt(f.answer)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
